function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupervisorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.56,22.37A.75.75,0,0,1,8.43,22a12.94,12.94,0,0,1,.09-2.15c.17-1.52.92-1.06,1-1.83.31-3.29,1.22-5.12,4.09-6.88a13.84,13.84,0,0,0,3.68,7.32C16.74,15,16.05,11.92,16,9.61c0-.39.09-1,.54-1.22a12.42,12.42,0,0,1,9,0c.45.17.55.83.54,1.22-.08,2.31-.77,5.36-1.28,8.84a13.84,13.84,0,0,0,3.68-7.32c2.87,1.76,3.78,3.59,4.09,6.88,0,.77.79.31,1,1.83A12.94,12.94,0,0,1,33.57,22a.67.67,0,0,1-.14.38Z",
    style: {
      fill: "#62a3ef",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.31,24.62c0,.1,0,.2,0,.31,0,4.38,4.54,9.52,10.42,9.52s10.87-5.14,10.87-9.52a3,3,0,0,0,0-.31Z",
    style: {
      fill: "#62a3ef",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisorIcon);
export default __webpack_public_path__ + "static/media/supervisor_icon.673de3646edbbd341d09b9af653700d1.svg";
export { ForwardRef as ReactComponent };